import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { BLOGS } from '../mock';

const BlogPost = () => {
  const { slug } = useParams();
  const post = BLOGS.find((b) => b.slug === slug) || BLOGS[0];

  if (!post) {
    return (
      <main className="bg-[#FFFFFF] min-h-screen py-24 text-center text-sm text-[#7a6a54]">
        Article not found. <Link to="/blogs" className="underline">Back to Journal</Link>
      </main>
    );
  }

  return (
    <main className="bg-[#FFFFFF] min-h-screen pb-24">
      {/* Editorial Article Header */}
      <section className="pt-12 pb-10 sm:pt-16 sm:pb-12">
        <div className="max-w-[840px] mx-auto px-6 text-center">
          <Link
            to="/blogs"
            className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-[#7a6a54] hover:text-[#1a1a1a] transition-colors mb-8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)]"
          >
            ← Back to Journal
          </Link>
          {post.category && (
            <span className="text-xs font-mono uppercase tracking-wider text-[#999959] font-medium block mb-3">
              {post.category}
            </span>
          )}
          <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal leading-tight tracking-tight">
            {post.title}
          </h1>
        </div>
      </section>

      {/* Large Editorial Hero Image */}
      <div className="max-w-[1100px] mx-auto px-6 mb-12 lg:mb-16">
        <div className="aspect-[16/9] w-full overflow-hidden bg-[#FBFBF9] border border-[#EEF1E4] shadow-sm">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Article Content Container */}
      <article className="max-w-[760px] mx-auto px-6">
        {post.sections && post.sections.length > 0 ? (
          post.sections.map((section, idx) => {
            if (section.type === 'heading') {
              return (
                <h2
                  key={idx}
                  className="font-serif text-2xl sm:text-3xl text-[#1a1a1a] font-normal mt-12 mb-5 leading-snug"
                >
                  {section.text}
                </h2>
              );
            }
            return (
              <p
                key={idx}
                className="text-base sm:text-lg text-[#5a5346] leading-relaxed font-sans mb-6"
              >
                {section.boldText && (
                  <strong className="font-semibold text-[#1a1a1a]">
                    {section.boldText}
                  </strong>
                )}
                {section.text}
              </p>
            );
          })
        ) : (
          <p className="text-base sm:text-lg text-[#5a5346] leading-relaxed font-sans mb-6">
            {post.body}
          </p>
        )}

        {/* Footer Category CTA */}
        <div className="mt-16 pt-8 border-t border-[#EEF1E4] flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link
            to="/blogs"
            className="text-xs font-mono uppercase tracking-wider text-[#7a6a54] hover:text-[#1a1a1a] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)]"
          >
            ← All Journal Articles
          </Link>
          {post.category && (
            <Link
              to={`/collections/${post.category}`}
              className="inline-block text-xs font-mono uppercase tracking-wider text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 hover:text-[var(--brand-green)] hover:border-[var(--brand-green)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)]"
            >
              Explore {post.category} Collection
            </Link>
          )}
        </div>
      </article>
    </main>
  );
};

export default BlogPost;

